export default __webpack_public_path__ + "static/media/IMG_8406.fec8685e.jpeg";